
import 'swiper/css/swiper.css'
import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import { QnaFormVO } from './vo/qna.vo'
import { MstCommonCodeVO } from "@/views/biz/order/vo/order.vo";

@Component
export default class QnaForm extends Vue{

    @Prop() productCd!: number;

    //data
    commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>; // 공통코드 (알림구분)
    qnaFormVO: QnaFormVO = {} as QnaFormVO;

    //initialized events
    created(): void {
        this.qnaFormVO.productCd = this.productCd;
        this.qnaFormVO.memCd = 1;
        this.qnaFormVO.regUser = 1;
        this.qnaFormVO.qnaTypeCd = "";
        this.qnaFormVO.isPublic =false;
      axios.get(`/common/code/codes/046`).then((r) => {
        this.commonCodes = r.data;
      });         
    }

    submitQnaForm() {
      if(!this.qnaFormVO.qcontents) {
        // 내용을 입력해주세요.
        return alert(this.$t('mypage.a0008'));
      }
      if(!this.qnaFormVO.qnaTypeCd) {
        // 문의유형을 선택해주세요.
        return alert(this.$t('mypage.a0012'));
      }
      if(this.qnaFormVO.memCd == null){
        alert("문의를 다시 작성해주세요.");
        this.$router.go(-1);
      }
      if(confirm(this.$t('common.c0001').toString())) {
        axios.post(`/product/qna`, this.qnaFormVO)
        .then((r) => {
            console.log(r);
            this.$router.go(-1);
        });
      }
    }
}
